import type { AddNeedResourceDetailsToActionRequest } from '@act/shared/types';
import type { ActionFormResourceDetails } from 'react-components/dialog-forms/components/useNeedActionFormtypes';

/**
 * Maps one resource referral form row to the need-action API shape (no CBO cache).
 *
 * @param details - Form row.
 * @returns Payload for a single resource referral.
 */
export function formatSingleResourceReferral(
  details: ActionFormResourceDetails
): AddNeedResourceDetailsToActionRequest {
  const { id, phoneNumber, ...rest } = details;
  const formattedPhoneNumber = phoneNumber
    ? '+1'.concat(phoneNumber.replace(/\D/g, ''))
    : undefined;

  return {
    resourceName: rest.resourceName,
    contactName: rest.contactName,
    url: rest.url,
    streetAddress: rest.streetAddress,
    city: rest.city,
    state: rest.state,
    zipcode: rest.zipcode,
    ...(formattedPhoneNumber && { phoneNumber: formattedPhoneNumber }),
    ...(id !== undefined && id > 0 && { id }),
    ...(rest.cboRecordId && { cboRecordId: rest.cboRecordId }),
  };
}
